var $29092b8c778be040$exports = {};
$29092b8c778be040$exports = {
    "Empty": `\u{7A7A}`
};


export {$29092b8c778be040$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
